/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 8.14286L17.0696 6.16956C18.6755 5.13718 19.4785 4.62099 20.1425 4.66841C20.7211 4.70974 21.2534 5.0003 21.601 5.46471C22 5.99762 22 6.95219 22 8.86133V15.1387C22 17.0478 22 18.0024 21.601 18.5353C21.2534 18.9997 20.7211 19.2903 20.1425 19.3316C19.4785 19.379 18.6755 18.8628 17.0696 17.8304L14 15.8571"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.06958 17.8304C10.6755 18.8628 11.4785 19.379 12.1425 19.3316C12.7211 19.2903 13.2534 18.9997 13.601 18.5353C14 18.0024 14 17.0478 14 15.1387V8.86133C14 6.95219 14 5.99762 13.601 5.46471C13.2534 5.0003 12.7211 4.70974 12.1425 4.66841C11.4785 4.62099 10.6755 5.13718 9.06957 6.16956L4.1872 9.30823C2.79366 10.2041 2.09688 10.652 1.85622 11.2216C1.64595 11.7192 1.64595 12.2808 1.85622 12.7784C2.09688 13.348 2.79366 13.7959 4.1872 14.6918L9.06958 17.8304Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M9.06958 17.8304C10.6755 18.8628 11.4785 19.379 12.1425 19.3316C12.7211 19.2903 13.2534 18.9997 13.601 18.5353C14 18.0024 14 17.0478 14 15.1387V8.86133C14 6.95219 14 5.99762 13.601 5.46471C13.2534 5.0003 12.7211 4.70974 12.1425 4.66841C11.4785 4.62099 10.6755 5.13718 9.06957 6.16956L4.1872 9.30823C2.79366 10.2041 2.09688 10.652 1.85622 11.2216C1.64595 11.7192 1.64595 12.2808 1.85622 12.7784C2.09688 13.348 2.79366 13.7959 4.1872 14.6918L9.06958 17.8304Z"
					fill="currentColor"
				/>
				<path
					d="M15.4696 7.19813C14.9328 7.54322 14.6644 7.71577 14.4698 7.9469C14.2976 8.1515 14.1682 8.38855 14.0892 8.64403C14 8.93266 14 9.25174 14 9.8899V14.1101C14 14.7483 14 15.0673 14.0892 15.356C14.1682 15.6115 14.2976 15.8485 14.4698 16.0531C14.6644 16.2842 14.9328 16.4568 15.4696 16.8019L17.0696 17.8304C18.6755 18.8628 19.4785 19.379 20.1425 19.3316C20.7211 19.2903 21.2534 18.9997 21.601 18.5353C22 18.0024 22 17.0478 22 15.1387V8.86133C22 6.95219 22 5.99762 21.601 5.46471C21.2534 5.0003 20.7211 4.70974 20.1425 4.66841C19.4785 4.62099 18.6755 5.13718 17.0696 6.16956L15.4696 7.19813Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M14 8.14286L17.0696 6.16956C18.6755 5.13718 19.4785 4.62099 20.1425 4.66841C20.7211 4.70974 21.2534 5.0003 21.601 5.46471C22 5.99762 22 6.95219 22 8.86133V15.1387C22 17.0478 22 18.0024 21.601 18.5353C21.2534 18.9997 20.7211 19.2903 20.1425 19.3316C19.4785 19.379 18.6755 18.8628 17.0696 17.8304L14 15.8571M4.1872 14.6918L9.06958 17.8304C10.6755 18.8628 11.4785 19.379 12.1425 19.3316C12.7211 19.2903 13.2534 18.9997 13.601 18.5353C14 18.0024 14 17.0478 14 15.1387V8.86133C14 6.95219 14 5.99762 13.601 5.46471C13.2534 5.0003 12.7211 4.70974 12.1425 4.66841C11.4785 4.62099 10.6755 5.13718 9.06957 6.16956L4.1872 9.30823C2.79366 10.2041 2.09688 10.652 1.85622 11.2216C1.64595 11.7192 1.64595 12.2808 1.85622 12.7784C2.09688 13.348 2.79366 13.7959 4.1872 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.80048 14.692C1.40694 13.7961 0.710166 13.3482 0.469506 12.7787C0.259227 12.281 0.259227 11.7194 0.469506 11.2218C0.710166 10.6522 1.40694 10.2043 2.80048 9.30844L10.4243 4.40743C11.5003 3.71569 12.0383 3.36983 12.4735 3.30903C13.3466 3.18706 14.1965 3.6511 14.566 4.45145C14.7502 4.85039 14.7502 5.48998 14.7502 6.76918L17.8196 4.79602C19.4255 3.76364 20.2285 3.24745 20.8925 3.29488C21.4711 3.33621 22.0034 3.62677 22.351 4.09117C22.75 4.62409 22.75 5.57866 22.75 7.48779V16.5126C22.75 18.4218 22.75 19.3763 22.351 19.9093C22.0034 20.3737 21.4711 20.6642 20.8925 20.7055C20.2285 20.753 19.4255 20.2368 17.8196 19.2044L14.7502 17.2313C14.7502 18.5104 14.7502 19.15 14.566 19.549C14.1965 20.3493 13.3466 20.8134 12.4735 20.6914C12.0383 20.6306 11.5003 20.2847 10.4243 19.593L2.80048 14.692Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 6.21429L9.33333 6V6C10.7071 5.11684 11.394 4.67526 11.9593 4.66375C12.6686 4.64929 13.3326 5.01177 13.704 5.61631C14 6.09799 14 6.91459 14 8.54777V15.1387C14 17.0478 14 18.0024 13.601 18.5353C13.2534 18.9997 12.7211 19.2903 12.1425 19.3316C11.4785 19.379 10.6755 18.8628 9.06958 17.8304L4.1872 14.6918C2.79366 13.7959 2.09688 13.348 1.85622 12.7784C1.64595 12.2808 1.64595 11.7192 1.85622 11.2216C2.09688 10.652 2.79366 10.2041 4.1872 9.30823L4.66667 9L5 8.78571L5.5 8.46429M14 15.8571L17.0696 17.8304C18.6755 18.8628 19.4785 19.379 20.1425 19.3316C20.7211 19.2903 21.2534 18.9997 21.601 18.5353C22 18.0024 22 17.0478 22 15.1387V7.75523C22 6.81264 22 6.34135 21.8989 6.03563C21.5686 5.03633 20.5203 4.46403 19.5011 4.72655C19.1893 4.80686 18.7929 5.06172 18 5.57143V5.57143L17.3333 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 8.14286L17.0696 6.16956C18.6755 5.13718 19.4785 4.62099 20.1425 4.66841C20.7211 4.70974 21.2534 5.0003 21.601 5.46471C22 5.99762 22 6.95219 22 8.86133V15.1387C22 17.0478 22 18.0024 21.601 18.5353C21.2534 18.9997 20.7211 19.2903 20.1425 19.3316C19.4785 19.379 18.6755 18.8628 17.0696 17.8304L14 15.8571M4.1872 14.6918L9.06958 17.8304C10.6755 18.8628 11.4785 19.379 12.1425 19.3316C12.7211 19.2903 13.2534 18.9997 13.601 18.5353C14 18.0024 14 17.0478 14 15.1387V8.86133C14 6.95219 14 5.99762 13.601 5.46471C13.2534 5.0003 12.7211 4.70974 12.1425 4.66841C11.4785 4.62099 10.6755 5.13718 9.06957 6.16956L4.1872 9.30823C2.79366 10.2041 2.09688 10.652 1.85622 11.2216C1.64595 11.7192 1.64595 12.2808 1.85622 12.7784C2.09688 13.348 2.79366 13.7959 4.1872 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.75 7.48755C22.75 5.57841 22.75 4.62384 22.351 4.09093C22.0034 3.62652 21.4711 3.33596 20.8925 3.29463C20.2285 3.24721 19.4255 3.7634 17.8196 4.79578L13.25 7.73336V16.2666L17.8196 19.2042C19.4255 20.2365 20.2285 20.7527 20.8925 20.7053C21.4711 20.664 22.0034 20.3734 22.351 19.909C22.75 19.3761 22.75 18.4215 22.75 16.5124V7.48755Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.7502 7.48755C14.7502 5.57841 14.7502 4.62384 14.3513 4.09093C14.0036 3.62652 13.4714 3.33596 12.8927 3.29463C12.2287 3.24721 11.4257 3.7634 9.8198 4.79578L2.80048 9.3082C1.40694 10.204 0.710166 10.652 0.469506 11.2215C0.259227 11.7192 0.259227 12.2808 0.469506 12.7784C0.710166 13.348 1.40694 13.7959 2.80048 14.6917L9.8198 19.2042C11.4257 20.2365 12.2287 20.7527 12.8927 20.7053C13.4714 20.664 14.0036 20.3734 14.3513 19.909C14.7502 19.3761 14.7502 18.4215 14.7502 16.5124V7.48755Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
